import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import { Row, Col, Table, Progress } from "antd";

@inject('store')
@observer
class RoomsRank extends Component {
    render() {
        const { data } = this.props.store.allHotel;
        const pdf = data.map(x =>
            ({ ...x, pdf: (x.pdf / 89) * 100 > 100 ? 100 : ((x.pdf / 89) * 100).toFixed(2) }))
            .sort((a, b) => (b.pdf - a.pdf))
            .map((x, i) => ({ ...x, index: i + 1 }));

        const columns = [{
            title: '排名',
            key: '排名',
            dataIndex: 'index',
            width: 100,
            render: (text, record, i) => {
                return (
                    <div className={`rank rank${text}`}>{text}</div>
                )
            }
        }, {
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '报表保存进度',
            dataIndex: 'pdf',
            key: 'pdf',
            width: 600,
            sorter: (a, b) => a.pdf - b.pdf,
            render: (text, record, i) => {
                return (
                    <div>
                        <Progress
                            percent={Number(text)}
                            className="schedule"
                            strokeWidth={15}
                            showInfo={false}
                            strokeLinecap="square"
                            strokeColor="#13C2C2"
                        />
                        <span>{text}%</span>
                    </div>
                )
            }
        }];

        const pagination = {
            total: data.length,
            pageSize: 5
        };
        return (
            <div className="rooms head-pdf">
                <Row>
                    <Col span={24}>
                        <div className="total_style">报表保存进度 Report Save Progress</div>
                        <Table
                            className="rank-table "
                            columns={columns}
                            dataSource={toJS(pdf)}
                            rowKey={(record, index) => record.id}
                            pagination={pagination}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default RoomsRank;


// WEBPACK FOOTER //
// ./src/components/BI/headquarters/Pdf.js